import {Alert, Button, message, Space} from "antd";
import {StyledShareServiceWidgetWrapper} from "../../calls/service/share-service-widget/share-service-widget.style";
import {ProfileWidgetSkeleton} from "../../calls/upcoming-calls/profile-widget/profile-widget-skeleton";
import {CopyIconSm, FacebookIconSm, MailIcon, XIcon} from "../../icons/icons";
import {handleLiveClassLink} from "../../../utils/live-class";
import {GetLiveEventApiResponse} from "../../../react-query-hooks/live-events/get-live-event/types";
import {useGetProfileContext} from "../../../context/profile/profile-context";

const ShareClassWidget = ({
  classData,
  isFetching,
}: {
  isFetching: boolean;
  classData: GetLiveEventApiResponse;
}) => {
  const {state: profileState} = useGetProfileContext();
  let stripedHtml = classData.description.replace(/<[^>]+>/g, "");
  const classDescription = stripedHtml;
  return (
    <StyledShareServiceWidgetWrapper>
      {isFetching ? (
        <ProfileWidgetSkeleton />
      ) : (
        <>
          <h2 className="profile-widget-heading">Share event link</h2>
          <div className="profile-widget-card">
            <Space size={16} direction="vertical" style={{display: "flex"}}>
              <div className="profile-widget-card-header">
                <h3 className="profile-widget-card-user-name">{classData.name}</h3>
                {/* <div>
                  <Button size="small" shape="circle" icon={<EditOutlined />} />
                </div> */}
              </div>
              <p className="profile-widget-card-bio">{classDescription}</p>

              <div>
                <Button
                  size="small"
                  block
                  htmlType="button"
                  target="_blank"
                  href={handleLiveClassLink({
                    eventId: classData.id,
                    slug: classData.slug,
                    tinyUrl: classData.tiny_url,
                    username: profileState.profileData.username,
                    windowNav: true,
                  })}
                >
                  View event page
                </Button>
              </div>
              <p className="profile-widget-card-bio">Share event via</p>
              <div>
                <Space direction="horizontal" size={12}>
                  <div
                    style={{
                      color: "#9254DE",
                      height: "3rem",
                      width: "3rem",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <a
                      href="#!"
                      title="Copy url"
                      onClick={() =>
                        navigator.clipboard
                          .writeText(
                            handleLiveClassLink({
                              eventId: classData.id,
                              slug: classData.slug,
                              tinyUrl: classData.tiny_url,
                              username: profileState.profileData.username,
                              windowNav: true,
                            })
                          )
                          .then(() => message.success("Copied!"))
                      }
                    >
                      <CopyIconSm style={{fontSize: "2rem"}} />
                    </a>
                  </div>
                  <div
                    style={{
                      color: "#3B5998",
                      height: "3rem",
                      width: "3rem",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <a
                      target="_blank"
                      rel="noreferrer"
                      href={`https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fcoachli.co%2F${profileState.profileData.username}&amp`}
                      title="Share on Facebook"
                    >
                      <FacebookIconSm style={{fontSize: "2rem"}} />
                    </a>
                  </div>
                  <div
                    style={{
                      border: "none",
                      height: "3rem",
                      width: "3rem",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <a
                      target="_blank"
                      rel="noreferrer"
                      href={`https://twitter.com/intent/tweet?text=Book a service with me on Coachli!&url=${handleLiveClassLink(
                        {
                          eventId: classData.id,
                          slug: classData.slug,
                          tinyUrl: classData.tiny_url,
                          username: profileState.profileData.username,
                          windowNav: true,
                        }
                      )}&hashtags=coachli,useCoachli`}
                      title="Share on X"
                    >
                      <XIcon style={{fontSize: "2rem"}} />
                    </a>
                  </div>
                  <div
                    style={{
                      border: "none",
                      height: "3rem",
                      width: "3rem",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <a
                      href={`mailto:?subject=I wanted you to see this site&amp;body=Book a service with me on Coachli ${handleLiveClassLink(
                        {
                          eventId: classData.id,
                          slug: classData.slug,
                          tinyUrl: classData.tiny_url,
                          username: profileState.profileData.username,
                          windowNav: true,
                        }
                      )}`}
                    >
                      <MailIcon style={{fontSize: "2rem"}} />
                    </a>
                  </div>
                </Space>
              </div>
            </Space>
          </div>
        </>
      )}
    </StyledShareServiceWidgetWrapper>
  );
};

export {ShareClassWidget};
